module.exports = __webpack_public_path__ + "static/media/menu-angle.eadc4eab.svg";